import { action } from 'satcheljs';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { RecipientWellWithFindControlViewState } from 'owa-readwrite-recipient-well/lib/orchestrators/removePersonaFromWellOrchestrator';

export default action(
    'updateMailTipsForRecipients',
    (
        composeId: string,
        recipientWell: RecipientWellWithFindControlViewState,
        recipients: ReadWriteRecipientViewState[]
    ) => ({
        composeId,
        recipientWell,
        recipients,
    })
);
